import React, {memo, useCallback, useMemo, useState} from 'react';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {useSelector} from 'react-redux';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {ControlTypeModel} from '../../../../types/control';
import {DEVELOPER_URL} from '../../index';

const columns: ColumnModel[] = [
    {
        length: 3,
        name: 'Kontrol Tip Adı',
        key: 'name',
    },
    {
        length: 2,
        name: 'Render Type',
        key: 'render_type',
    },
    {
        length: 2,
        name: 'Anasayfada Gör.',
        key: 'show_on_homepage',
    },
    {
        length: 2,
        name: 'Kontrol Sayısı',
        key: 'bridge_device_type_count',
    },
];

const keyExtractor = (item: ControlTypeModel) => item.id;

export const ControlTypeListScreen = memo(function ControlTypeListScreen() {

    const controlTypeList = useSelector(state => state.control.controlTypeList);

    const [selectedControlType, setSelectedControlType] = useState<ControlTypeModel<unknown>>(null);

    const buttons = useMemo(() => [
        {
            text: 'DÜZENLE',
            url: `/developer/control-type/edit/${selectedControlType ? selectedControlType.id : ''}`,
            className: 'orange',
            hidden: !(selectedControlType),
        },
        // {
        //     text: 'Kontrol Tip OLUŞTUR',
        //     url: '/developer/control-type/edit',
        //     className: 'green',
        // },
    ], [selectedControlType]);

    const displayNameExtractor = useCallback((item: ControlTypeModel, column: ColumnModel) => {
        if (column.key === 'bridge_device_type_count') {
            return item.allowed_bridge_device_type_id_list.length.toString();
        }

        if (column.key === 'show_on_homepage') {
            return item.show_on_homepage ? 'Evet' : 'Hayır';
        }

        return item[column.key] || '-';
    }, []);

    return (
        <PasswordContainer requiredRole='developer' isFullscreen={true}>
            <SettingsPageContainer
                buttons={buttons}
                className="camera-list-page"
                backUrl={DEVELOPER_URL}>
                <SettingsList
                    columns={columns}
                    items={controlTypeList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedControlType}
                    onItemSelected={setSelectedControlType}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
